import { Component } from '@angular/core';

@Component({
  selector: 'app-condizioni',
  templateUrl: './condizioni.component.html',
  styleUrls: ['./condizioni.component.css']
})
export class CondizioniComponent { }
